export const getProjAndEnvKeysFromSelfLink = (link: string) => {
  const destination = link.split('destinations')[1];
  const projKey = destination?.split('/')[1];
  const envKey = destination?.split('/')[2];
  return [projKey, envKey];
};
